import { useEffect, useMemo, useState } from 'react';
import { useMutationObserver } from './useMutationObserver';
const getColorSchemeFromElement = (element) => {
    if (!element)
        return undefined;
    const hasEnforcedLightScheme = element.classList.contains('light-scheme');
    if (hasEnforcedLightScheme)
        return 'light';
    const hasEnforcedDarkScheme = element.classList.contains('dark-scheme');
    if (hasEnforcedDarkScheme)
        return 'dark';
    return undefined;
};
export const useClosestColorScheme = (element) => {
    const closestParentWithColorScheme = useMemo(() => element === null || element === void 0 ? void 0 : element.closest('.wave'), [element]);
    const [closestColorScheme, setClosestColorScheme] = useState();
    useEffect(() => {
        const colorScheme = getColorSchemeFromElement(closestParentWithColorScheme);
        setClosestColorScheme(colorScheme);
    }, [closestParentWithColorScheme]);
    const callback = mutations => {
        const lastMutation = mutations[mutations.length - 1];
        const changedElement = lastMutation.target;
        setClosestColorScheme(getColorSchemeFromElement(changedElement));
    };
    useMutationObserver(closestParentWithColorScheme, callback, { attributes: true, attributeFilter: ['class'] });
    return closestColorScheme;
};
